import DateAdapter from '@mui/lab/AdapterDayjs'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded'

export default function DatePicker({ label, target, disabled, className, value, onChange, textColor, ...props }) {
  const { current } = useLoading()
  const t = useI18n()
  disabled = !!(disabled || current)
  const [open, setOpen] = useState(false)
  return (
    <LocalizationProvider dateAdapter={ DateAdapter }>
      <DesktopDatePicker
        disableMaskedInput
        open={ open }
        onOpen={
          () => {
            if (disabled) return
            setOpen(true)
          }
        }
        onClose={ () => setOpen(false) }
        allowSameDateSelection
        label={ label }
        disabled={ disabled }
        value={ value }
        onChange={ onChange }
        renderInput={ props => {
          const parentStyle = () => {
            if (target) return
            return 'relative h-[4.3rem] pt-[1.1rem]'
          }
          const renderTarget = () => {
            if (target) return target
            return (
              <div className={ cn('border-b border-gray-400 inline-block cursor-pointer hover:border-black pb-[0.12rem] flex justify-between hover:border-b-2', className) }
              >
                <div className='absolute top-[-0.2rem] left-0 text-[0.75rem] text-gray-500'>{ label }</div>
                <div className={ cn('text-[0.95rem] pt-[0.15rem]', textColor) }>{ renderValue() }</div>
                <div className='py-[0.02rem] text-gray-600 hover:text-black'>
                  <DateRangeRoundedIcon />
                </div>
              </div>
            )
          }
          const renderValue = () => {
            if (!value) return ''
            return t.time(value).format('YYYY-MM-DD (dd)')
          }
          return (
            <>
              <div className={ parentStyle() }
              >
                <div className={ cn('fixed opacity-10 h-screen w-screen top-0 left-0', { hidden: !open }) }
                  onClick={ () => setOpen(false) }
                  style={ { zIndex: 200 } }
                ></div>
                <div className='absolute h-0 w-0 left-1/2 overflow-hidden'>
                  <C.Input className='' { ...props } />
                </div>
                <div
                  onClick={ () => setOpen(true) }
                >
                  {renderTarget()}
                </div>
              </div>
            </>
          )
        }
        }
        { ...props }
      />
    </LocalizationProvider>
  )
}
